import { useState } from "react"
import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import { useFetchRateCardsConfigsQuery } from "../../../../../redux/queries"
import Form from "../../../form"

interface Props {
  integration: Integration
}

const RateCardsSelector = ({ integration }: Props) => {
  const { app_settings, saveSetting } = useIntegrationSettingsForm(integration)

  const [selectedID, setSelectedRateCardsID] = useState<string>(
    String(app_settings?.settings?.rateCardsConfigId ?? "")
  )

  const { data: rateCards = [], isLoading } = useFetchRateCardsConfigsQuery(
    { brand_id: integration?.brand_id },
    { skip: !integration?.brand_id }
  )

  const setSelected = (rateCardsID: string) => {
    if (rateCardsID !== selectedID) {
      setSelectedRateCardsID(rateCardsID)
      saveSetting({ rateCardsConfigId: rateCardsID })
    }
  }

  return (
    <Form.Select
      label="Choose a rate cards config"
      showLabel={false}
      size="sm"
      isLoading={isLoading}
      data={rateCards}
      setSelected={setSelected}
      selected={selectedID || undefined}
    />
  )
}

export default RateCardsSelector
